
export const LOADER_STATUS = 'boilerplate/UserModule/LOADER_STATUS';
export const SET_USER_MODULE = 'boilerplate/UserModule/SET_USER_MODULE';
export const SET_MASTER_MODULE = 'boilerplate/UserModule/SET_MASTER_MODULE';